export const PLANN3R_COLOR = '#10365D'
export const MS_CLIENT_ID =
  process.env.REACT_APP_MS_CLIENT_ID || 'a4245e47-2b01-4e89-b06a-59e24a8dcd51'
export const APP_URL = process.env.REACT_APP_APP_URL || 'http://localhost:3000'
export const GTM_ID = process.env.REACT_APP_GTM_ID || 'W4NFHLF'
export const API_URI = process.env.REACT_APP_API_URI || 'http://localhost:8080/letsgapp-0.0.1-web'
export const SERVERLESS_API_URI = process.env.REACT_APP_API_URI || 'http://localhost:8082/v1'
export const MIDDLE_END_URI =
  process.env.REACT_APP_MIDDLE_END_URI || 'http://localhost:8081'
export const CHARGEBEE_SITE = process.env.REACT_APP_CHARGEBEE_SITE || 'helloplan-test'
